import axios from 'axios';

/**
 * Get full Strapi URL from path
 * @param {string} path - Path of the URL
 * @returns {string} - Full URL
 */
export const getStrapiURL = (path = '') => {
    return `${process.env.REACT_APP_STRAPI_URL || 'http://localhost:1337'
        }${path}`;
};

/**
 * Helper to get the media URL (handles images hosted on external providers)
 * @param {object} media - Media object
 * @returns {string} - Full URL
 */
export const getStrapiMedia = (media) => {
    if (!media) {
        return '';
    }

    let url;

    // Handle different Strapi media response structures
    if (typeof media === 'string') {
        url = media;
    } else if (media.url) {
        url = media.url;
    } else if (media.data) {
        if (Array.isArray(media.data)) {
            // If it's an array of media (e.g. multiple images), return the first one's URL
            if (media.data.length > 0) {
                url = media.data[0].attributes ? media.data[0].attributes.url : media.data[0].url;
            }
        } else {
            // Single media object
            url = media.data.attributes ? media.data.attributes.url : media.data.url;
        }
    } else if (media.attributes && media.attributes.url) {
        url = media.attributes.url;
    } else if (Array.isArray(media) && media.length > 0) {
        url = media[0].url || (media[0].attributes && media[0].attributes.url);
    }

    if (!url) {
        return '';
    }

    const imageUrl = url.startsWith('/') ? getStrapiURL(url) : url;
    return imageUrl;
};

/**
 * Helper to make GET requests to Strapi API endpoints
 * @param {string} path - URL path
 * @param {object} params - URL parameters
 * @returns {Promise} - Data or error
 */
export const fetchAPI = async (path, params = {}) => {
    try {
        const requestUrl = getStrapiURL(`/api${path}`);
        const response = await axios.get(requestUrl, {
            params,
        });
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const postAPI = async (path, data = {}) => {
    try {
        const requestUrl = getStrapiURL(`/api${path}`);
        // Strapi requires the payload to be wrapped in a 'data' object
        const response = await axios.post(requestUrl, {
            data: data, 
        });
        return response.data;
    } catch (error) {
        console.error("API Post Error:", error.response?.data || error.message);
        throw error;
    }
};